<template>
  <div class="float-left">
    <span style="padding-left:5px;" class="block-options" v-on:click="helpModal=true">
      <button class="btn btn-outline-secondary helpBorder"><b>?</b></button>
    </span>
    <b-modal hide-footer size="lg" v-model="helpModal" @ok="helpModal = false">
      <div class="modal-body">
        <img class="helpImg" src="./7.jpg" height="100%" width="100%">
       </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      helpModal:false
    }
  },
  mounted(){
  },
  methods: {
  }
}
</script>

<style scoped>
.helpBorder {
  border-color:#d3d3d3 !important;
  border-radius: 15px !important;
  padding-top: 0px !important;
  padding-right: 11px !important;
  padding-left: 5px !important;
  max-height: 20px !important;
  max-width: 15px !important;
}
.helpHr1 {
  /* display: block; */
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  /* border-style: inset; */
  background-color: #fff;
  border-top: 5px dashed #8c8b8b;
}
.helpHr2 {
  /* display: block; */
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  /* border-style: inset; */
  background-color: #fff;
  border-top: 2px dashed #8c8b8b;
}
/* div.modal.my-modal .modal-dialog {
  width: 1200px !important;
} */
/* .modal-dialog{
    overflow-y: initial !important
} */
.modal-body{
    height: 700px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/helpModals/budget/budgetHelpForm01.vue